module.exports = __webpack_public_path__ + "static/media/icon_edit.30324c73.svg";